module.exports = __webpack_public_path__ + "img/title-brand-story.75480860.svg";